var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './shared/assets/css/index.css';
import './shared/assets/css/override.css';
import { LocaleProvider } from 'antd';
import tr_TR from 'antd/lib/locale-provider/tr_TR';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import provide from 'src/shared/decorators/provide';
import AuthStore from 'src/stores/AuthStore';
import UserStore from 'src/stores/UserStore';
import { initialize } from 'aurelia-pal-browser';
import App from './App';
initialize();
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Root.prototype.render = function () {
        return this.props.children;
    };
    Root.childContextTypes = {};
    Root = __decorate([
        provide({
            authStore: new AuthStore(),
            userStore: new UserStore()
        })
    ], Root);
    return Root;
}(React.Component));
ReactDOM.render(React.createElement(Root, null,
    React.createElement(LocaleProvider, { locale: tr_TR },
        React.createElement(App, null))), document.getElementById('root'));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 616
// module chunks = 0